import type { JSX } from "solid-js";
import { Show } from "solid-js";
import type { Id } from "@thisbeyond/solid-dnd";
import type { MovableItem } from "./Moveable";
import Moveable from "./Moveable";
import LastDropZone from "../../pages/formEditor/editor/LastDropZone";
import type { Stringifiable } from "../../types";
import { Key } from "@solid-primitives/keyed";

type DroppableListProps<T extends Stringifiable> = {
  type: string;
  items: MovableItem<T>[];
  ignoredZones: Id[];
  fallback?: JSX.Element;
};

const DroppableList = <T extends Stringifiable>(props: DroppableListProps<T>) => (
  <div class="flex size-full flex-col">
    <Show when={props.items.length > 0} fallback={props.fallback}>
      <div class="flex flex-col gap-2">
        <Key each={props.items} by={(item) => item.id}>
          {(element) => (
            <div data-type={props.type} id={element().id.toString()}>
              <Moveable ignoredZones={props.ignoredZones} item={element()} />
            </div>
          )}
        </Key>
      </div>
      <LastDropZone ignoredItems={props.ignoredZones} />
    </Show>
  </div>
);

export default DroppableList;
